// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/.pnpm/css-loader@5.2.7_webpack@4.47.0/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".widget-skeleton-dimensions[data-v-0d643c8c]{height:104px}@media screen and (width:1024px){.widget-skeleton-dimensions[data-v-0d643c8c]{width:136px}}@media screen and (min-width:1025px){.widget-skeleton-dimensions[data-v-0d643c8c]{width:auto}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
